
import React from "react";
import { Button } from "@/components/ui/button";

interface SkillsFiltersProps {
  categories: string[];
  difficulties: string[];
  selectedCategory: string;
  selectedDifficulty: string;
  setSelectedCategory: (category: string) => void;
  setSelectedDifficulty: (difficulty: string) => void;
}

export const SkillsFilters = ({
  categories,
  difficulties,
  selectedCategory,
  selectedDifficulty,
  setSelectedCategory,
  setSelectedDifficulty,
}: SkillsFiltersProps) => {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:justify-between">
      <div className="flex gap-2 flex-wrap">
        <p className="text-sm font-medium text-gray-700 my-auto mr-2">Categories:</p>
        {categories.map((category) => (
          <Button
            key={category}
            variant={selectedCategory === category ? "default" : "outline"}
            onClick={() => setSelectedCategory(category)}
            className="transition-all"
            size="sm"
          >
            {category}
          </Button>
        ))}
      </div>
      <div className="flex gap-2 flex-wrap">
        <p className="text-sm font-medium text-gray-700 my-auto mr-2">Difficulty:</p>
        {difficulties.map((difficulty) => (
          <Button
            key={difficulty}
            variant={selectedDifficulty === difficulty ? "default" : "outline"}
            onClick={() => setSelectedDifficulty(difficulty)}
            className="transition-all"
            size="sm"
          >
            {difficulty}
          </Button>
        ))}
      </div>
    </div>
  );
};
